import { useLayoutEffect } from 'react';

/**
 * Custom hook that scrolls to a specified element by its ID.
 * @param {string} elementId - The ID of the element to scroll to.
 */
const useScrollToElement = (elementId: string, offset = 100) => {
  useLayoutEffect(() => {
    const scrollToElement = () => {
      const element = document.getElementById(elementId);
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'instant',
        });
      }
    };

    const element = document.getElementById(elementId);
    if (element) {
      scrollToElement();
    } else {
      const observer = new MutationObserver((mutations, obs) => {
        const element = document.getElementById(elementId);
        if (element) {
          scrollToElement();
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    }
  }, [elementId]);
};

export default useScrollToElement;
